import {
  MetricsV1AggregationType,
  MetricsV1AggregationThresholdDirection as ThresholdDirection,
} from '@spotify/confidence-graphql';

// Aggregation types that should default to "replace missing with zero" behavior.
// Used by Average and Ratio measurement forms when setting nullHandling defaults.
export const replaceEntityNullWithZeroAggs = [
  MetricsV1AggregationType.AggregationTypeSum,
  MetricsV1AggregationType.AggregationTypeCount,
  MetricsV1AggregationType.AggregationTypeCountDistinct,
];

export const getAggregationTypeLabel = (type: MetricsV1AggregationType) => {
  const prefix = 'AGGREGATION_TYPE_';
  return type.startsWith(prefix)
    ? type.substring(prefix.length).split('_').join(' ')
    : type;
};

export const getAggregationTypeSqlLabel = (type: MetricsV1AggregationType) => {
  const prefix = 'AGGREGATION_TYPE_';
  return type.startsWith(prefix) ? type.substring(prefix.length) : type;
};

const aggregationThresholdDirectionDetails: Record<
  ThresholdDirection,
  { label: string; description: string }
> = {
  [ThresholdDirection.AggregationThresholdDirectionEq]: {
    label: '=',
    description: 'Equal to',
  },
  [ThresholdDirection.AggregationThresholdDirectionGt]: {
    label: '>',
    description: 'Greater than',
  },
  [ThresholdDirection.AggregationThresholdDirectionGte]: {
    label: '≥',
    description: 'Greater than or equal to',
  },
  [ThresholdDirection.AggregationThresholdDirectionLt]: {
    label: '<',
    description: 'Less than',
  },
  [ThresholdDirection.AggregationThresholdDirectionLte]: {
    label: '≤',
    description: 'Less than or equal to',
  },
};

export const getAggregationThresholdDirectionDetails = (
  direction: ThresholdDirection,
) => {
  return (
    aggregationThresholdDirectionDetails[direction] || {
      label: 'Unknown',
      description: direction,
    }
  );
};

// Aggregation types available for non-HLL (HyperLogLog) measurements
const nonHLLAggregationTypes = [
  MetricsV1AggregationType.AggregationTypeAvg,
  MetricsV1AggregationType.AggregationTypeCount,
  MetricsV1AggregationType.AggregationTypeCountDistinct,
  MetricsV1AggregationType.AggregationTypeMax,
  MetricsV1AggregationType.AggregationTypeMin,
  MetricsV1AggregationType.AggregationTypeSum,
];

export function getEnabledAggregationTypes(
  isHLL: boolean,
): MetricsV1AggregationType[] {
  if (isHLL) {
    return [MetricsV1AggregationType.AggregationTypeApproxCountDistinct];
  }
  return nonHLLAggregationTypes;
}

export function getDefaultAggregationType(
  isHLL: boolean,
): MetricsV1AggregationType {
  return isHLL
    ? MetricsV1AggregationType.AggregationTypeApproxCountDistinct
    : MetricsV1AggregationType.AggregationTypeCount;
}

export function formatCapValue(value: string | undefined | null): string {
  if (value !== undefined && value !== null && !isNaN(parseFloat(value))) {
    return value;
  }
  return 'No cap';
}
